var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNew(_vm.timestamp))?_c('span',{staticClass:"caption-sticker"},[_vm._v("NEU")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }